import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useClerkAuth';
import { getQuestionUsageStats } from '@/services/questionUsage';

interface UsageStats {
  questionsUsed: number;
  questionsRemaining: number;
  resetDate?: Date;
  isPro: boolean;
}

export function useUsageStats(catalogId: string) {
  const { user, hasProAccess, isAuthenticated } = useAuth();
  const [usageStats, setUsageStats] = useState<UsageStats>({
    questionsUsed: 0,
    questionsRemaining: 0,
    isPro: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsageStats = async () => {
      if (!isAuthenticated || !user?.id) {
        setLoading(false);
        return;
      }

      try {
        const stats = await getQuestionUsageStats(
          user.id,
          hasProAccess,
          catalogId
        );
        setUsageStats(stats);
      } catch (error) {
        console.error('Failed to fetch usage stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsageStats();
  }, [user?.id, hasProAccess, catalogId, isAuthenticated]);

  return {
    usageStats,
    loading,
    isAuthenticated,
    hasProAccess,
  };
}
